import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Achievements from './Achievements';
import HeroSection from './HeroSection';
import Card from './Card';
import Owl from './Owl';
import Services from './Services';
import Technologies from './Technologies';
import { Helmet } from 'react-helmet';

const SwiftIndex = (props) => {
    const { slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Top Swift App Development Company</title>
                <meta name="description" content="We are one of the leading and most experienced Swift development companies who deliver superb and high performance mobile apps with our Swift developers." />
            </Helmet>
            <HeroSection />
            <Achievements />
            <Services />
            <Technologies />
            {/* <Owl /> */}
            <Card />
        </>
    )
}

export default SwiftIndex